import React from 'react';
import { connect } from 'react-redux';

import { Text } from 'platform-components';
import getStudentName from 'platform-components/src/utils/get-student-name';

import * as classSelectors from 'common.components/classes/selectors';
import * as userSelectors from 'common.components/user/selectors';

import * as selectors from '../selectors';

export type StoreProps = ReturnType<typeof mapStateToProps>;

export interface Props {
    teamId: number;
}

export const AssignmentCollapsedStudentsComponent = ({
    currentTeam,
    students,
    selectedStudents,
}: Props & StoreProps) => {
    if (selectedStudents.length === students?.length) {
        return (
            <div className="assignment__students-placeholder">
                <Text
                    id="lessonView.assignment.studentsPlaceholder.allStudents"
                    values={{ level: currentTeam?.level, name: currentTeam?.name }}
                />
            </div>
        );
    }

    return (
        <div className="assignment__students-placeholder">
            {students &&
                students
                    .filter((student) => selectedStudents.includes(student.id))
                    .map((student) => (
                        <div className="assignment__student-placeholder" key={student.id}>
                            <Text>{getStudentName(student.firstName, student.lastName)}</Text>
                        </div>
                    ))}
        </div>
    );
};

const mapStateToProps = (storeState: any, { teamId }: Props) => ({
    currentTeam: userSelectors.getCurrentClass(storeState, { classId: teamId }),
    students: classSelectors.getStudents(storeState, { classId: teamId }),
    selectedStudents: selectors.getSelectedStudents(storeState),
});

export const AssignmentCollapsedStudents = connect(mapStateToProps)(AssignmentCollapsedStudentsComponent);
